<template>
  <!--Card content-->
  <div>
    <OverviewIcons :activity="activity"></OverviewIcons>
    <h2 class="card-title"> {{activity.translations[language].name}}</h2>
    <DescriptionHeader :activity="activity"></DescriptionHeader>
    <div class="description m-t-2">
      <p v-if="activity.translations[language]" v-for="line in activity.translations[language].description.split('\n')">
        {{line}}
      </p>
    </div>

  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import OverviewIcons from './OverviewIcons';
import DescriptionHeader from './DescriptionHeader';


export default {
  name: 'ActivityDescription',
  components: {
    OverviewIcons,
    DescriptionHeader,
  },
  computed: {
    ...mapState({
      activity: state => state.activityPublic.activity,
      language: state => state.language,
    }),
    ...mapGetters([
      'activityRegion',
    ]),
  },
};
</script>

<style lang="scss" scoped>
.card-block {
  position: relative;
  p {
    margin-bottom: 0;
    min-height: 24px;
  }
}
.card-title {
  padding-right: 70px;
}
.cancelationDays {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// ActivityDescription.vue?028f475d